export const REQUEST_PERSIST_SELECTION: 'RECIPE/REQUEST_PERSIST_SELECTION' = 'RECIPE/REQUEST_PERSIST_SELECTION';
export const REQUEST_TOGGLE_TOOLTIP: 'RECIPE/REQUEST_TOGGLE_TOOLTIP' = 'RECIPE/REQUEST_TOGGLE_TOOLTIP';
export const REQUEST_HIDE_TOOLTIP: 'RECIPE/REQUEST_HIDE_TOOLTIP' = 'RECIPE/REQUEST_HIDE_TOOLTIP';
